<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <!-- tab -->
      <div class="content">
        <div class="top-box">
          <div class="btn">
            + 上传文件
            <input
              type="file"
              class="upload-input"
              ref="input"
              @change="
                (e) => {
                  handleUpload(e, 'keyFileName');
                }
              "
            />
          </div>
        </div>
        <div class="import-result-container">
          <!-- 顶部状态文字 -->
          <div class="status-header">
            <div
              v-for="(line, index) in textInfo"
              :key="index"
              class="status-line"
            >
              {{ line }}
            </div>
          </div>

          <!-- 核心表格：不再使用 pre 标签，改用 table -->
          <table v-if="tableData.length > 0" class="custom-table">
            <thead>
              <tr>
                <th v-for="(cell, index) in tableHeader" :key="index">
                  {{ cell }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in tableBody" :key="rowIndex">
                <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                  {{ cell }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'BatchUpdateLabel',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '画像标签',
        secondTitle: 'AI诊断规则'
      },
      rawString: ''
    };
  },

  mounted() {

  },
  computed: {
    // 解析出的纯文字部分
    textInfo() {
      const lines = this.rawString.split('\n');
      // 过滤掉包含表格边框符号的行，保留状态描述行
      return lines.filter(l => l && !/[┌├└│─]/.test(l));
    },
    // 解析出的表格总数据
    tableData() {
      const lines = this.rawString.split('\n');
      // 只提取带“│”符号的数据行
      const dataLines = lines.filter(line => line.includes('│'));

      return dataLines.map(line => {
        // 1. 去掉首尾的边框符
        // 2. 按中间的边框符拆分
        // 3. 去掉每个单元格多余的空格
        return line
          .trim()
          .replace(/^│|│$/g, '')
          .split('│')
          .map(cell => cell.trim());
      });
    },
    // 表头
    tableHeader() {
      return this.tableData.length > 0 ? this.tableData[0] : [];
    },
    // 表体
    tableBody() {
      return this.tableData.slice(1);
    }
  },
  methods: {
    handleUpload(e, name) {
      let file = e.target.files[0];
      this.loading++;
      this.httpUploadFile(
        this.$root.uploadDiagnostic,
        {
          file: file
        },
        { 'Content-Type': 'multipart/form-data' }
      ).then(
        (res) => {
          this.loading--;
          this.$refs.input.value = '';
          this.$message.success('上传成功');
          this.rawString = res.describe;
        },
        (res) => {
          this.loading--;
          this.$refs.input.value = '';
          this.$message.error(res);
        }
      );
    },
    deleteLabel(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定删除该标签吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteServicer, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getLabelList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        position: relative;
        .upload-input {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            opacity: 0;
            cursor: pointer;
          }
      }

      .import-result {
        margin-top: 24px;
      }

      .import-result {
        /* 必须指定等宽字体，且要包含中文字体 */
        font-family:
          "SF Mono",           /* macOS */
          "Menlo",             /* macOS 备选 */
          "Consolas",          /* Windows */
          "Liberation Mono",   /* Linux */
          "Courier New",       /* 通用备选 */
          monospace;           /* 最终兜底 */

        /* 关键：确保中文也按等宽渲染 */
        font-variant-east-asian: full-width;

        font-size: 13px;
        line-height: 1.6;
        background: #f8f9fa;
        padding: 16px;
        border-radius: 6px;
        white-space: pre;
        overflow-x: auto;      /* 表格太宽时允许横向滚动 */
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 12px;
      }

      .select, .input {
        width: 160px;
      }

      .date-input {
        width: 360px;
      }

      .btn-box {
        margin: 0;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
    word(14px, #333);
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
}

.tabs {
  width: 100%;
  background: #fff;
  height: 60px;
  flex-x(flex-start);
  padding: 0 30px;
  box-sizing: border-box;
  margin-top: 8px;
  flex-shrink: 0;

  .tab {
    background: #fff;
    cursor: pointer;
    padding: 0 15px;
    position: relative;
    width: auto;
    margin-right: 100px;
    height: 100%;
    flex-x(center);
    word(16px, #999);

    &.active {
      word(16px, #333);

      .tab-line {
        width: 100%;
        position: absolute;
        background: #4678E6;
        height: 4px;
        border-radius: 2px;
        left: 0;
        bottom: 3px;
      }
    }
  }
}

.import-result-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding: 16px;
  background: #fff;
  color: #333;
  // line-height: 1.6;
}

.status-header {
  margin-bottom: 16px;
  white-space: pre-wrap; /* 保证文字部分的换行 */
}

.status-line {
  margin-bottom: 4px;
  font-size: 14px;
}

/* 重点：自定义表格样式替代 ASCII 边框 */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  border: 1px solid #ebeef5;
  font-size: 13px;
}

.custom-table th {
  background-color: #f5f7fa;
  color: #909399;
  font-weight: bold;
  text-align: left;
}

.custom-table th,
.custom-table td {
  padding: 10px 14px;
  border: 1px solid #ebeef5;
}

.custom-table tr:hover {
  background-color: #fafafa;
}
</style>
